import { useUserStore } from '@/store/user'  // Changed from entityDataStore
import { useEntityStore } from '@/store/useEntityStore'  // Changed from entityDataStore
import { useAnnouncementStore } from '@/store/announcement'  // Changed from entityDataStore
import { logout } from '@/services/webservice'
import { useRouter} from 'vue-router'
import { clearApolloCache } from '@/services/graphql/client'
import {useLogger} from "@/composables/useLogger"
import {subsystemUrls} from '@/config'
const {sendLog} = useLogger() 
const logoutRequest = logout
/**
 * Composable for path controller functionality
 * @returns {object} - Path controller functions and computed properties
 */
export function usePathController() {
  const router = useRouter()
  const userStore = useUserStore()
  const entityStore = useEntityStore()
  const announcementStore = useAnnouncementStore()

  const goTo = (addr, query = {}, params = {}) => {
  if (!addr) return;
  if (addr.startsWith('http://') || addr.startsWith('https://')) {
    window.location.href = addr; // Absolute URL, redirect
  } else {
    addr = {path: addr, query, params }
    router.push(addr); 
  }
}

const goToLogin = (errorMessage) => {
  goTo( '/login' , {errorMessage})
}

const goToEntity  = (path) => {
  goTo(`/admin-control/${path}`)
}

const goToHome = () => {
    goTo("/profile")
  }
const followRedirection = async (response) => {
  try {
    const { domain = "", path = "" } = response
    if(!domain || !path) return goToHome()
    const allowedOrigins = new Set(
      Object.values(subsystemUrls).map(value => new URL(value).origin)
    )

    const url = new URL(path, domain)
    if (!allowedOrigins.has(url.origin)) {
      throw new Error("Invalid redirect origin")
    }

    window.location.assign(url.toString())

  } catch (error) {
    // await userStore.handlePostLogin()
    goToHome()
  }
}

const goToUserProfile = (userId) => {   
  goTo("/admin-control", { userId })
}

const getLoginPath = () => {
  if(userStore.userId) return [null, "/profile"]
  else if(userStore.challengeMetadata){
    if(userStore.challengeMetadata.name === "MFA_SETUP")
      return [null, "/mfa-setup"]
    else if(userStore.challengeMetadata.name === "SOFTWARE_TOKEN_MFA")
      return  [null, "/mfa-confirmation"]
  }
}

const logoutCoordinator = async () => {  
  
  await attemptLogoutWithRetry()

  userStore.$reset() 
  entityStore.$reset()
  announcementStore.$reset()  
  await clearApolloCache()
  }

async function attemptLogoutWithRetry(maxRetries = 3) {
  let attempt = 0

  while (attempt < maxRetries) {
    try {
      await logoutRequest()
      window.location.replace('/login')
      return
    } catch (e) {
      if(e.status === 401) {
        return 
      }
      attempt++

      const delay = 1000 * Math.pow(2, attempt)
      await new Promise(res => setTimeout(res, delay))
    }
  }
}

const withTimeout = (promise, ms = 3000) => {
  return Promise.race([
    promise,
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error('Auth timeout')), ms)
    )
  ])
}

 const initAuth = async() => {
      try {
          await withTimeout(userStore.getCurrentUser())
      } catch (e) {
        sendLog("error", "get_current_user", {event: "timeout_is_triggered", error: e})
      }
    }

  
  return {
    goTo,
    getLoginPath,
    goToLogin,
    goToEntity,
    goToHome,
    goToUserProfile,
    logoutCoordinator,
    initAuth,
    followRedirection
  }
}
